import { render, staticRenderFns } from "./MoratoriaSoja.vue?vue&type=template&id=14a1a30a&lang=pug"
import script from "./MoratoriaSoja.vue?vue&type=script&lang=js"
export * from "./MoratoriaSoja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports